import { render, staticRenderFns } from "./GetInTouch.vue?vue&type=template&id=5ae69996&scoped=true&lang=pug&"
import script from "./GetInTouch.vue?vue&type=script&lang=js&"
export * from "./GetInTouch.vue?vue&type=script&lang=js&"
import style0 from "./GetInTouch.vue?vue&type=style&index=0&id=5ae69996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae69996",
  null
  
)

export default component.exports